import useGlobalContext from "hooks/globalData";
import useListTitle from "hooks/useListTitle";
import { useNavigate } from "react-router-dom";
import { IMediaItem } from "services/KnowfullyAdminClient";
import MediaLibraryItemsListView from "./MediaLibraryItemsListView";

const MediaLibraryItemsList = () => {
  const navigate = useNavigate();
  const { mediaLibraryItemDetailsUrl } = useGlobalContext();

  useListTitle("mediaLibrary");

  const onClickMediaLibraryItem = (mediaLibraryItem: IMediaItem) => {
    navigate(mediaLibraryItemDetailsUrl(mediaLibraryItem.id));
  };

  return (
    <MediaLibraryItemsListView
      onClickMediaLibraryItem={onClickMediaLibraryItem}
    />
  );
};

export default MediaLibraryItemsList;
